import InputToolTip from './input-tool-tip';

export default InputToolTip;